export interface Passwords {
  oldPassword?: string;
  password: string;
  confirmPassword: string;
}

export const isEmailValid = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const isPhoneValid = (phone: string) => {
  return /^\d{7,15}$/g.test(phone);
};

export const isPasswordStrong = (password: string) => {
  if (!password.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=\S+$).{8,16}$/)) {
    return false;
  }
  return password.length >= 8 && password.length <= 16;
};

export const isValidHttpUrl = (url: string) => {
  try {
    if (!url || url.startsWith('/')) {
      return true;
    }
    const urlType = new URL(url);
    return ['http:', 'https:'].includes(urlType.protocol);
  } catch (_err) {
    return false;
  }
};

export const confirmPasswordFieldIsEqual = (emailLoginPasswords: Passwords) => {
  return emailLoginPasswords.password === emailLoginPasswords.confirmPassword;
};
